// extracted by mini-css-extract-plugin
export default {"background":"LoginBannerItem_background__X2Xee","modal":"LoginBannerItem_modal__bwd5d","modalBackground":"LoginBannerItem_modalBackground__hkvMB"};